import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { IngestionSettingsRequestActions } from '../ingestionSettings';
import { getOrgId } from '../fullstory/selectors';
import { AppDispatch, AppState } from '../../types';
import { useNotifications } from '@fullstory/react-hooks';
import { useEffect } from 'react';
import { DetectionsConfigurationRules } from '@fullstory/proto/fs/services/ingestion-settings';
import { useRequestState } from '../../utils/hooks';

export const useDetectionsConfigRules = () => {
  const intl = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const notifications = useNotifications();
  const orgId = useSelector(getOrgId);
  const requestStateStatus = useRequestState(
    (state: AppState) => state.ingestionSettings.detectionsConfigRules,
  );

  useEffect(() => {
    dispatch(IngestionSettingsRequestActions.getDetectionsConfigRules(orgId, false)).catch(() => {
      notifications?.error(
        intl.formatMessage({
          defaultMessage:
            'Failed to fetch detections configuration rules. Try refreshing the page.',
          id: 'CvvJRF',
        }),
        'DETECTIONS_CONFIG_RULES',
      );
    });
  }, [dispatch, intl, notifications, orgId]);

  const updateDetectionsConfigRules = (detectionsConfigRules: DetectionsConfigurationRules) =>
    dispatch(
      IngestionSettingsRequestActions.updateDetectionsConfigRules(orgId, detectionsConfigRules),
    ).then(() => {
      dispatch(IngestionSettingsRequestActions.getDetectionsConfigRules(orgId, true)).catch(() => {
        notifications?.error(
          intl.formatMessage({
            defaultMessage: 'Failed to update DetectionsConfigRules',
            id: 'obHojy',
          }),
          'DETECTIONS_CONFIG_RULES',
        );
      });
    });

  return {
    detectionsConfigRules: requestStateStatus.data,
    isReady: requestStateStatus.isReady,
    error: requestStateStatus.hasError,
    updateDetectionsConfigRules,
  };
};

export const useDetectionsEnabled = () => {
  const { detectionsConfigRules, isReady } = useDetectionsConfigRules();

  return isReady && detectionsConfigRules?.detectionsConfigRules?.detectionsEnabled;
};
